import { responseStatus } from "common/constants";

export default function getResponseColor(status) {
	switch (status) {
		case responseStatus.success:
			return '#DCFCE7';
		case responseStatus.error:
			return '#fee2e2';
		case responseStatus.warning:
			return '#FEF3C7'
		default:
			return null;
	}
}
